import { PaginatedResponse } from "api/common/types/response.types";
import { Product } from "api/memberPortal/project/product/product.types";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import ProductsInFinalReviewColumns from "./ProductsInFinalReviewTable.columns";

interface ProductsInFinalReviewTableProps {
  products: PaginatedResponse<Product> | undefined;
  isLoading: boolean;
}

export const ProductsInFinalReviewTable = ({
  products,
  isLoading,
}: ProductsInFinalReviewTableProps) => {
  return (
    <DefaultDataGrid
      columns={ProductsInFinalReviewColumns}
      rows={products?.results}
      loading={isLoading}
      title={"Products In Final Review"}
      getRowId={(row) => row.v_id}
    />
  );
};

export default ProductsInFinalReviewTable;
